// Manages periodic fetching and distribution of GOM averages data to registered listeners.
// Uses a polling mechanism with configurable intervals to keep data fresh.

import { getGOMAverages } from "./API/GOMAverages/GOMAverages";
import { IGOMAveragesSet } from "./API/GOMAverages/GOMAveragesSet";
import { IGOMAveragesListener } from "./IGOMAveragesListener";

export class GOMAveragesManager {

    // Interval in ms between data refreshes (30 s)
    private interval = 30000;

    // Stores the most recently received GOM averages data
    public latestData: IGOMAveragesSet = null;

    // List of registered listeners that receive updates when data changes
    private listeners: IGOMAveragesListener[] = [];

    // Registers a new listener to receive GOM averages updates
    public addListener(listener: IGOMAveragesListener): void {
        this.listeners.push(listener);
    }

    // Starts the periodic data refresh cycle
    public start(): void {
        this.cancelled = false;
        this.refresh(true);
    }

    // Stops the periodic data refresh cycle
    public stop(): void {
        this.cancelled = true;
    }

    // Flag indicating whether operations should be cancelled
    private cancelled: boolean;

    // Tracks whether we're waiting for a timeout to complete
    private timeoutWaiting: boolean = false;

    // Refreshes GOM averages data and notifies registered listeners
    public refresh(repeat = false): void {
        getGOMAverages((err: any, data: IGOMAveragesSet) => {
            if (this.cancelled) {
                return;
            }

            if (data !== null) {
                this.latestData = data;
            }

            // Notify all listeners of the data change
            this.listeners.forEach((listener: IGOMAveragesListener) => {
                try {
                    listener.GOMAveragesChanged(this.latestData);
                } catch (error) { }
            });

            // Schedule next refresh if requested and not already pending
            if (repeat && !this.timeoutWaiting) {
                window.setTimeout(() => {
                    this.timeoutWaiting = false;
                    this.refresh(true);
                }, this.interval);
                this.timeoutWaiting = true;
            }
        });
    }
}